// Side-effect module imported first by src/index.js: it must run before any
// other module (and before Sentry.init) so the token in the URL fragment is
// removed before anything can read or record `location.href`.
import { consumeImpersonationFragment } from './impersonationSession';

consumeImpersonationFragment();
